<div class="container">
  <div class="row">
    <div class="col-12 col-md-8 col-lg-6 col-xl-5 mx-auto">
      <div class="bhakts-container">
        <div class="card login-form">
          <div class="card-body">
            <h3 class="card-title text-center">BHAKTS LOGIN</h3>
            <div class="card-text login-form1">
              @if (isInvalid) {
                <div class="alert alert-danger alert-dismissible fade show" role="alert">{{errMessage}}
                </div>
              }
              <form class="admin-form" (ngSubmit)="adminLogin()">
                <!-- to error: add class "has-danger" -->
                <div class="user-form">
                  <div class="form-group">
                    <label for="exampleInputEmail1">Username</label>
                    <input type="text" name="username" class="form-control form-control-sm" id="exampleInputEmail1"
                      placeholder="Enter your Username" [(ngModel)]="username" required>
                  </div>
                </div>
                <div class="user-form">
                  <div class="form-group">
                    <label for="password">Password</label>
                    <a href="#" style="float:right;font-size:12px;">Forgot password?</a>
                    <input type="password" name="password" class="form-control form-control-sm" id="password"
                      placeholder="Enter your password" [(ngModel)]="password" required>
                  </div>
                </div>
                <div class="log-btn"><button type="submit" class="btn btn-primary btn-dashboard w-100">Sign in</button>
              </div>
              <!-- <div class="sign-up">
              Don't have an account? <a routerLink="/signup">Sign Up</a>
            </div> -->
            <router-outlet></router-outlet>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
